
package ru.it_mozaika.sender.js.application.frames.subscribers


import js.core.jso
import mui.material.*
import mui.material.SortDirection
import mui.system.responsive
import mui.system.sx
import react.*
import react.dom.aria.ariaLabel
import react.dom.aria.ariaLabelledBy
import react.router.useNavigate
import ru.it_mozaika.sender.common.models.UserRole
import ru.it_mozaika.sender.js.application.*
import ru.it_mozaika.sender.js.application.components.StoresSelect
import ru.it_mozaika.sender.js.application.components.subscribers.subscriptionDialog
import ru.it_mozaika.sender.js.application.context.*
import ru.it_mozaika.sender.js.application.frames.MainCard
import tanstack.react.table.renderCell
import tanstack.react.table.renderHeader
import tanstack.react.table.useReactTable
import tanstack.react.virtual.UseVirtualizerOptions
import tanstack.react.virtual.useVirtualizer
import tanstack.table.core.*
import web.cssom.*
import web.file.File
import web.html.HTMLDivElement

private enum class Steps(val ruTitle: String) {
    Upload( "Загрузка файла"),
    Fields("Заполнение полей"),
//    Subscribe("Тэги/подписки")
}

val AddSubscribersFrame = VFC {
    val stepperContext = useContext(AddSubscribersStepperContext)
    val activeStep = stepperContext.activeStep
    val navigate = useNavigate()
    Grid {
        container = true
        spacing = responsive(2)
        Grid {
            item = true
            asDynamic().xs = 12
            MainCard {
                title = "Загрузка контактов"
                actions = Stack.create {
                    direction = responsive(StackDirection.row)
                    spacing = responsive(2)
                    Button {
                        variant = ButtonVariant.outlined
                        color = ButtonColor.secondary
                        +"Назад"
                        onClick = {
                            stepperContext.changeStep(activeStep - 1)
                            if (activeStep - 1 == 0) stepperContext.clearData()
                        }
                        disabled = activeStep == 0
                        startIcon = mui.icons.material.ArrowBackSharp.create()
                    }
//                    Button {
//                        variant = ButtonVariant.outlined
//                        color = ButtonColor.secondary
//                        +"Далее"
//                        onClick = {
//                            stepperContext.changeStep(activeStep + 1)
//                        }
//                        disabled = !stepperContext.emailIsIndicated
//                                || stepperContext.subscribers.isEmpty()
//                                || stepperContext.file == null
//                                || stepperContext.activeStep == 2
//                        startIcon = mui.icons.material.ArrowForwardSharp.create()
//                    }
                    Button {
                        variant = ButtonVariant.outlined
                        color = ButtonColor.secondary
                        +"Завершить"
                        onClick = {
                            navigate("/subscribers")
                            stepperContext.changeStep(0)
                            stepperContext.clearData()
                        }
                        startIcon = mui.icons.material.ExitToAppSharp.create()
                    }
                }
                Stepper {
                    alternativeLabel = true
                    this.activeStep = activeStep
                    sx {
                        margin = 10.px
                    }
                    Steps.entries.forEachIndexed{ index, step ->
                        Step {
                            key = step.name
                            completed = index < activeStep
                            StepButton {
                                + step.ruTitle
                                asDynamic().onClick = {
                                    stepperContext.changeStep(index)
                                    if (index == 0) stepperContext.clearData()
                                }
                                asDynamic().disabled = when(step){
                                    Steps.Upload -> false
                                    Steps.Fields -> !stepperContext.emailIsIndicated
//                                    Steps.Subscribe -> stepperContext.subscribers.isEmpty()
                                }
                                asDynamic().color = "secondary"
                            }
                        }
                    }
                }
            }
        }
        Grid {
            item = true
            asDynamic().xs = 12
            when (activeStep) {
                0 -> FileUpload {}
                1 -> DataProcessing {}
//                2 -> Subscribe {}
            }
        }
    }
}

private val FileUpload = VFC {
    val stepperContext = useContext(AddSubscribersStepperContext)
    val file = stepperContext.file
    Card {
        CardContent {
            Dropzone {
                behaviour = "replace"
                accept =
                    ".csv, .txt, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                onChange = {
                    val value = if (it.isNotEmpty()) it.first().file.unsafeCast<File>() else null
                    stepperContext.setFile(value)
                }
                maxFiles = 1
                maxFileSize = 20000000
                value = if (file != null) arrayOf(file) else arrayOf()
                this.autoClean = true
                this.onClean = {
                    stepperContext.setFile(null)
                }
                localization = "RU-ru"
                footerConfig = jso {
                    this.customFooter = Typography.create {
                        sx {
                            margin = 5.px
                        }
                        +"Доступные форматы - XLSX, CSV и TXT"
                    }
                }
            }
        }
    }
}

private val DataProcessing = VFC {
    val currentUser = useUser().currentUser
    val stepperContext = useContext(AddSubscribersStepperContext)
    val columnIdentifier = stepperContext.columnIdentifier
    val propertiesInUse = stepperContext.propertiesInUse
    val properties = stepperContext.properties
    val columns = stepperContext.columns
    val data = useMemo(stepperContext.fileData) { stepperContext.fileData }
    val parentRef = useRef<HTMLDivElement>()
    var showDialog by useState(false)
    var subscribe by useState(false)
    val virtualList = useVirtualizer(
        jso<UseVirtualizerOptions<HTMLDivElement, HTMLDivElement>> {
            this.getScrollElement = useCallback(parentRef.current) { parentRef.current }
            this.estimateSize = { 5 }
            overscan = 15
            this.count = data.size
        }
    )
    val table = useReactTable<Map<String, String>>(
        options = jso {
            this.columns = useMemo(columns) {
                columns.map { column ->
                    jso<ColumnDef<Map<String, String>, Any>> {
                        this.accessorFn = { entry, _ ->
                            entry[column]?.let {
                                it.ifBlank { "---" }
                            } ?: "---"
                        }
                        cell = ColumnDefTemplate { context ->
                            Box.create() {
                                sx {
                                    minHeight = 50.px
                                    minWidth = 100.px
                                }
                                +context.getValue().toString()
                            }
                        }
                        id = column
                        header = StringOrTemplateHeader(column)
                    }
                }
            }.toTypedArray()
            this.data = useMemo(data) { data.toTypedArray() }
            this.state = jso {
                this.columnVisibility = columnVisibility
                this.columnOrder = columnOrder
            }
            this.getCoreRowModel = getCoreRowModel()
            this.debugTable = true
            this.debugHeaders = true
            this.debugColumns = true
        }
    )
    subscriptionDialog {
        this.emailVerified = stepperContext.emailVerified
        this.isOpen = showDialog
        onClose = {
            showDialog = false
        }
        this.subscribe = subscribe
        this.subscribers = stepperContext.subscribers
    }
    MainCard {
        CardHeader {
            title = Stack.create {
                direction = responsive(StackDirection.row)
                spacing = responsive(2)
                StoresSelect()
                FormControlLabel {
                    control = Switch.create {
                        disabled = currentUser?.id != "677f71baf8bc6c7e661e087b" && currentUser?.role != UserRole.Admin
                        color = SwitchColor.secondary
                        onChange = { _, status ->
                            stepperContext.setEmailVerified(status)
                        }
                        checked = useMemo(stepperContext.emailVerified) { stepperContext.emailVerified }

                    }
                    label = ReactNode("Email верифицирован")
                }
            }
            action = Stack.create {
                spacing = responsive(2)
                direction = responsive(StackDirection.row)
                Button {
                    variant = ButtonVariant.outlined
                    color = ButtonColor.secondary
                    + "Загрузить/Обновить"
                    onClick = {
                        stepperContext.importRequest()
                    }
                    disabled = !stepperContext.emailIsIndicated
                    startIcon = mui.icons.material.UploadSharp.create()
                }
                Button {
                    disabled = !stepperContext.emailIsIndicated
                    color = ButtonColor.success
                    variant = ButtonVariant.outlined
                    + "Подписать: ${stepperContext.subscribers.size}"
                    onClick = {
                        showDialog = true
                        subscribe = true
                    }
                    startIcon = mui.icons.material.DoneAllSharp.create()
                }
                Button {
                    disabled = !stepperContext.emailIsIndicated
                    + "Отписать: ${stepperContext.subscribers.size}"
                    variant = ButtonVariant.outlined
                    color = ButtonColor.error
                    onClick = {
                        showDialog = true
                        subscribe = false
                    }
                    startIcon = mui.icons.material.UnsubscribeSharp.create()
                }
            }
        }
        TableContainer {
            ref = parentRef
            sx {
                marginRight = 5.px
                minWidth = 500.px
                maxHeight = 100.vh - 70.px
            }
            Table {
                ariaLabel = "file-processing-table"
                ariaLabelledBy = "file-processing-table-title"
                stickyHeader = true
                TableHead {
                    table.getHeaderGroups().forEach { headerGroup ->
                        headerGroup.headers.forEach { header ->
                            val headerName = renderHeader(header).toString()
                            TableCell {
                                key = header.id
                                align = TableCellAlign.center
                                padding = TableCellPadding.normal
                                sortDirection = SortDirection.asc
                                FormControl {
                                    sx {
                                        minWidth = 100.px
                                    }
                                    fullWidth = true
                                    InputLabel {
                                        +headerName
                                    }
                                    Select {
                                        color = InputBaseColor.secondary
                                        val selectedField = useMemo(
                                            columnIdentifier,
                                            headerName,
                                            properties
                                        ) { columnIdentifier[headerName] }
                                        this.id = "property-id-select"
                                        labelId = "property-id-select-label"
                                        variant = SelectVariant.outlined
                                        this.error = selectedField == null
                                        this.label = ReactNode(selectedField?.name ?: "---")
                                        this.value = selectedField?.id ?: ""
                                        renderValue = {
                                            ReactNode(selectedField?.name ?: "")

                                        }
                                        onChange = { event, _ ->
                                            val propertyId = event.target.value
                                            val selectedProperty = properties.find { it.id == propertyId }
                                            if (selectedProperty != null) {
                                                stepperContext.setColumnIdentifier(headerName, selectedProperty)
                                            }
                                        }
                                        if (selectedField != null) {
                                            this.startAdornment = mui.icons.material.ClearSharp.create {
                                                onClick = {
                                                    stepperContext.deleteFromColumnIdentifier(headerName)
                                                }
                                            }
                                        }
                                        properties.forEach { property ->
                                            MenuItem {
                                                this.disabled = propertiesInUse.contains(property)
                                                key = property.id
                                                value = property.id
                                                ListItemText {
                                                    primary = ReactNode(property.name)
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                TableBody {
                    virtualList.getVirtualItems().forEach { item ->
                        val row = table.getRowModel().rows[item.index]
                        val labelId = "file-processing-table-row-${item.index}"
                        TableRow {
                            tabIndex = -1
                            sx {
                                cursor = Cursor.pointer
                            }
                            hover = true
                            row.getVisibleCells().forEachIndexed { index, cell ->
                                TableCell {
                                    id = labelId
                                    scope = "row"
                                    padding = TableCellPadding.none
                                    align = TableCellAlign.center
                                    +renderCell(cell)
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

private val Subscribe = VFC {
    val stepperContext = useContext(AddSubscribersStepperContext)
    val tags = listOf("tag1", "tag2", "tag3")
    val (selectedTags, setSelectedTags) = useState<List<String>>(tags)
    var showDialog by useState(false)
    var subscribe by useState(false)
    subscriptionDialog {
        this.isOpen = showDialog
        onClose = {
            showDialog = false
        }
        this.subscribe = subscribe
        this.subscribers = stepperContext.subscribers
    }
    Grid {
        container = true
        spacing = responsive(2)
        Grid {
            sx {
                "& .MuiPaper-root" {
                    height = 100.pct
                }
            }
            item = true
            asDynamic().xs = 6
            MainCard {
                title = "Подписки"
                actions = Stack.create {
                    this.direction = responsive(StackDirection.row)
                    asDynamic().spacing = 1
                    Button {
                        color = ButtonColor.secondary
                        variant = ButtonVariant.outlined
                        +"Подписать: ${stepperContext.subscribers.size}"
                        onClick = {
                            showDialog = true
                            subscribe = true
                        }
                        startIcon = mui.icons.material.AddCircleOutlineSharp.create()
                    }
                    Button {
                        +"Отписать: ${stepperContext.subscribers.size}"
                        variant = ButtonVariant.outlined
                        color = ButtonColor.error
                        onClick = {
                            showDialog = true
                            subscribe = false
                        }
                        startIcon = mui.icons.material.UnsubscribeSharp.create()
                    }
                }
            }
        }
        Grid {
            sx {
                "& .MuiPaper-root" {
                    height = 100.pct
                }
            }
            item = true
            asDynamic().xs = 6
            MainCard {

                title = "Тэги"
                actions = Stack.create {
                    this.direction = responsive(StackDirection.row)
                    asDynamic().spacing = 1
                    Button {
                        +"Добавить тег"
                        startIcon = mui.icons.material.AddCircleOutlineSharp.create()
                        variant = ButtonVariant.outlined
                        color = ButtonColor.secondary
                        onClick = {

                        }
                    }
                }
            }
        }
    }
}